import React from 'react';
import { useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { ADD_TO_CART } from '../apollo/queries';
import './css/ProductModal.css';

const ProductModal = ({ product, onClose }) => {
  const navigate = useNavigate();
  const [quantity, setQuantity] = React.useState(1);
  
  // 제품의 실제 옵션을 사용, 없으면 기본 옵션
  const availableOptions = product.options && product.options.length > 0 ? product.options : ['옵션 없음'];
  const [selectedOption, setSelectedOption] = React.useState(availableOptions[0]);

  const handleIncrease = () => setQuantity(q => q + 1);
  const handleDecrease = () => setQuantity(q => (q > 1 ? q - 1 : 1));

  // 장바구니 추가 뮤테이션
  const [addToCart, { loading: addingToCart }] = useMutation(ADD_TO_CART, {
    onCompleted: () => {
      alert('장바구니에 추가되었습니다.');
      onClose();
    },
    onError: (error) => {
      console.error('장바구니 추가 에러:', error);
      alert('로그인 후 사용해주십시오 .');
    }
  });

  // 장바구니 담기 핸들러
  const handleAddToCart = () => {
    addToCart({
      variables: {
        productId: product.id,
        quantity: quantity,
        option: selectedOption !== '옵션 없음' ? selectedOption : null
      }
    });
  };

  // 상세보기 핸들러
  const handleViewDetail = () => {
    navigate(`/product?id=${product.id}`);
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>옵션 선택</h2>
          <button className="modal-close-btn" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="modal-body">
          <div className="modal-body-inner">
            <div className="option-row">
              <span className="option-label">제품명</span>
              <div className="option-value-box product-name-box">
                <span className="option-value">{product.name || '미입력'}</span>
              </div>
            </div>
            <div className="option-row">
              <span className="option-label">제품 번호</span>
              <div className="option-value-box product-code-box">
                <span className="option-value">{product.productCode || product.id || '미입력'}</span>
              </div>
            </div>
            <div className="option-row">
              <span className="option-label">부스바 사이즈</span>
              <div className="option-value-box">
                <span className="option-value">{product.size || '미입력'}</span>
              </div>
            </div>
            <div className="option-row">
              <span className="option-label">도금 옵션</span>
              <div className="option-select-box">
                <div className="select-background"></div>
                <select value={selectedOption} onChange={(e) => setSelectedOption(e.target.value)}>
                  {availableOptions.map((option, index) => (
                    <option key={index} value={option}>{option}</option>
                  ))}
                </select>
                <img src="/polygon-110.svg" alt="드롭다운" className="select-arrow" />
              </div>
            </div>
            <div className="option-row">
              <span className="option-label">수 량</span>
              <div className="quantity-control-wrapper">
                <div className="quantity-control">
                  <button onClick={handleDecrease}>
                    <img src="/frame-17074820260.svg" alt="감소" className="quantity-icon" />
                  </button>
                  <div className="quantity-value-box">
                    <span className="quantity-value">{quantity}</span>
                  </div>
                  <button onClick={handleIncrease}>
                    <img src="/frame-17074820270.svg" alt="증가" className="quantity-icon" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn-cancel" onClick={onClose}>
            <div>취 소</div>
          </button>
          <button className="btn-detail" onClick={handleViewDetail}>
            <div>상세보기</div>
          </button>
          <button 
            className="btn-add-to-cart" 
            onClick={handleAddToCart}
            disabled={addingToCart}
          >
            <div>{addingToCart ? '추가 중...' : '장바구니 담기'}</div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductModal; 